export const FormBottom = () => {
    return (
        <footer className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 border-border pt-4">
            <br /><br />
            <p className="text-sm text-muted-foreground text-center">
                Copyright © {new Date().getFullYear()} Wyszukiwarka Gadżetów. Wszystkie prawa zastrzeżone.
            </p>
        </footer>
    );
}